<template>
  <modal @close="$emit('cancel')">
    <div slot="body">
      <div class="alert alert-warning text-center mb-0">
        <strong>Warning!</strong>
        <slot>
          <p class="mb-0">{{ message }}</p>
        </slot>
      </div>
      <slot name="extra" />
    </div>
    <div slot="footer">
      <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" :disabled="loading" @click.prevent="$emit('confirm')">Confirm</button>
        <button class="btn btn-outline-primary ml-2" @click.prevent="$emit('cancel')">Cancel</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'ConfirmModal',
  components: { Modal },
  props: {
    // Fallback body; ignored when slot content is provided
    message: { type: String, default: null },
    loading: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmModal.vue